import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Form, Input } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../App';
import { Backdrop, CircularProgress } from '@mui/material';
import Img from "./image/cri_logo.jpg";
import Crilogo from './image/CRIOvalLogo.jpg';
import Logindms from './image/Login_dms.jpg';

function App() {
  const navigate = useNavigate();

  const [inputs, setInputs] = useState({ name: "", password: "" })
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = React.useState(false);
useEffect(() => {
  localStorage.clear();
}, []);


  const handleChange = (event) => {
    setInputs({ ...inputs, [event.target.name]: event.target.value })
  };

  const handleFormsubmit = (event) => {
    event.preventDefault();
    setOpen(true);
    let data = { loginid: inputs.name, password: inputs.password }

    axios.post(BASE_URL + '/login', data).then(({ data }) => {
      localStorage.setItem('Token', data.token);
      localStorage.setItem('USER_NAME', data.USER_NAME);
      //localStorage.setItem('USER_ID', data.USER_ID);
      localStorage.setItem('LOGIN_ID', data.LOG_ID);
      localStorage.setItem('GROUP_CODE', data.GROUP_CODE);
      localStorage.setItem('EMAIL_ID', data.EMAIL_ID);
      localStorage.setItem('BRANCH_CODE', data.BRANCH_CODE);
      localStorage.setItem('usertype', data.usertype);
      //localStorage.setItem('code',data.code);
      localStorage.setItem('USER_ID', data.code);
	  localStorage.setItem('clientip', data.clientip);
      navigate('/Home')
    }).catch((error) => {
      Swal.fire({
        icon: "warning",
        text: error.response.data.message
      });
    }).finally(() => {
      setOpen(false);
    });
  }

  const ForgotPasswordClick = () => {
    navigate('/Forgot_Password', {
        state: {
            Input_Login_ID: inputs.name,
        }
    });
}

  const css = `
        body {
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 120vh;
            color: #333;
			background-image: url(${Logindms});
            background-size: cover;
            background-position: center;
            backdrop-filter: blur(2px);
        }

        .container {
            width: 100%;
            max-width: 400px;
            padding: 0 20px;
            margin-top:-160px;
        }

        .card1 {
            width: 100%;
            background-color: #fff;
            padding: 20px;
            border-radius: 8px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        h2 {
            text-align: center;
            color: #333;
        }

        input {
            padding: 10px;
            margin-bottom: 12px;
            border: 1px solid #ddd;
           
            transition: border-color 0.3s ease-in-out;
            outline: none;
            color: #333;
            width: 100%;
        }

        input:focus {
            border-color: #fd1a2e;
        }

        button {
            width: 100%;
            background-color: #004aff ;
            color: #fff;
            padding: 10px;
            border: none;
            border-radius: 15px;
            cursor: pointer;
            transition: background-color 0.3s ease-in-out;
          
        }

        button:hover {
            background-color: #4365b7;
        }
        
       
        .label{
            float: left;
        }
		
		@keyframes infiniteAnimation {
            0% {
                transform: scaleX(1);
            }
            50% {
                transform: scaleX(1.1);
            }
            100% {
                transform: scaleX(1);
            }
        }

        .animated-text {
            display: inline-block;
            animation: infiniteAnimation 2s infinite;
            transform-origin: bottom;
        }`;

  return (
    <div className="container">
      <div className="card1">
        <center>
          <img
            src={Crilogo}
            alt="logo"
            className="mt-2 mb-3"
            style={{
              borderRadius: '10%',
             width:'20%'
            }}
          />
          <h2
			className="mb-2"
            style={{
              fontWeight: '1000',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)'
            }}
          >
         
          </h2>
        </center>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
          <CircularProgress color="inherit" />
        </Backdrop>

        <form onSubmit={handleFormsubmit}
          autoComplete="off"
          style={{
            width: 300,
            height: 250,
          }}

        ><Form.Item style={{ height: '50px', borderRadius: '10px', fontWeight: 'bold' }}
          type="text"
          id="name"
          rules={[
            {
              message: 'Please enter your username!',
            },
          ]}
        ><Input prefix={<UserOutlined className="name" />} name="name" placeholder="Login ID" onChange={handleChange} style={{ height: '50px' }} />
          </Form.Item>

          <Form.Item
            id="password"
            name="password"
            style={{ height: '50px', borderRadius: '10px' }}
            rules={[
              {
                message: 'Please enter your password!',
              },
            ]}>
            <Input.Password prefix={<LockOutlined className="lock" />} name="password" placeholder="Password" onChange={handleChange} style={{ height: '50px' }} />
          </Form.Item>
          <button name="submit">Log in</button>
          <br />
          <center className="mt-2">
            <span className="text-primary mb-3" onClick={ForgotPasswordClick}><u>Forgot Password</u></span>
            <br />
            {/* <p className="mt-4 text-muted text-small" style={{float:'right'}}>Powered By &nbsp;<span style={{ cursor: 'pointer' }}>
				<a href='https://grsystems.co.in/' target='_blank'>
					<i className="animated-text"><u style={{ color: '#004aff' }}><>GR Systems</></u></i>
				</a>
			</span></p> */}
            <p className="mt-4 text-muted text-small" style={{ float: 'right', fontSize: '0.75rem', textAlign: 'right',marginRight:'-10px' }}>
              Powered By &nbsp;
              <span style={{ cursor: 'pointer' }}>
                <a href='https://grsystems.co.in/' target='_blank'>
                  <i className="animated-text">
                    <u style={{ color: '#004aff' }}>GR Systems</u>
                  </i>
                </a>
              </span>
            </p>
            <p className="mt-4 text-muted text-small" style={{ float: 'left', fontSize: '0.75rem', textAlign: 'left',marginLeft:'-10px' }}>
              <span style={{ cursor: 'pointer'}}>
                <a href='https://dms.cri.in:8443/cridms_ver23/' target='_blank'>
                  {/* <i className="animated-text"> */}
                    <u style={{ color: '#004aff' ,  display: 'inline-block', padding: '0 20px' , fontWeight: 'bold'  }}> Switch To Old DMS</u>
                  {/* </i> */}
                </a>
              </span>
			  
            </p>
          </center>
        </form>
      </div>
      <style>{css}</style>
    </div>
  );
}

export default App;